<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 4000 4000"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <circle :style="{fill: color}" cx="2000" cy="2000" r="2000"/>
  <g id="_789103024">
   <path class="fil1" d="M809 2270c0,110 109,84 233,84l1815 0c58,0 86,9 116,39 68,67 52,194 -24,239 -47,27 -111,19 -182,19l-1598 0c-117,0 -213,4 -294,108 -159,202 13,453 214,453l2006 0c84,0 104,-152 -10,-154l-1927 0c-59,0 -89,4 -129,-19 -17,-10 -27,-20 -38,-36 -32,-42 -32,-101 0,-144 48,-65 108,-55 188,-55l1636 0c94,0 181,0 255,-72 161,-156 119,-408 -63,-501 -31,-16 -73,-30 -118,-30l-2011 0c-33,0 -69,36 -69,69z"/>
   <path class="fil1" d="M1841 1068c0,57 57,67 83,91 108,102 50,210 -7,324 -31,61 -50,107 -66,183 -33,161 61,334 149,334 64,0 120,-77 42,-143 -69,-59 -44,-176 -17,-244 51,-126 112,-173 112,-344 0,-130 -126,-280 -227,-280 -38,0 -69,38 -69,79z"/>
   <path class="fil1" d="M1142 1285c0,141 -143,254 -143,455 0,160 127,318 213,240 30,-28 30,-71 10,-102 -11,-17 -69,-39 -69,-138 0,-186 264,-393 78,-644 -167,-224 -296,-30 -194,35 51,32 105,66 105,154z"/>
   <path class="fil1" d="M2746 1058c0,76 43,66 86,104 169,149 -86,331 -86,584 0,149 125,313 213,234 30,-28 30,-71 10,-102 -11,-17 -69,-40 -69,-132 0,-200 264,-399 78,-650 -35,-46 -100,-107 -163,-107 -33,0 -69,36 -69,69z"/>
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'UnderfloorHeating',
  props: {
    color: {
      type: String,
      required: false,
      default: '#CCCCCC',
    },
  },
};
</script>

<style scoped>
.fil1 {fill:#FEFEFE}
</style>
